module.exports = __webpack_public_path__ + "static/media/DevTerritorial_PictoCdlT.c8ed148e.png";